import { render, staticRenderFns } from "./PostAutor.vue?vue&type=template&id=d637dc68&scoped=true"
import script from "./PostAutor.vue?vue&type=script&lang=js"
export * from "./PostAutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d637dc68",
  null
  
)

export default component.exports